import KNB from '@dp/knb';
import Toast from 'vant/lib/toast';
import Store from '@/store/index';
import URL from '@/util/url';

/**
 * 获取登录验证bizlogintoken，并存在sessionStorage中
 */
const getToken = () => {
  // 获取token

  const bizlogintoken = URL.getParameterByKey('bizlogintoken') || sessionStorage.getItem('bizlogintoken') || '';

  if (bizlogintoken) {
    sessionStorage.setItem('bizlogintoken', bizlogintoken);
    Store.commit('setBizlogintoken', bizlogintoken);
  } else {
    Toast('登录信息失效，请关闭页面重新打开');
  }
};

/**
 * 获取url携带的门店id参数pid
 * 获取开店宝当前门店poiId
 */
const getNowPoiId = () => {
  const urlPid = URL.getParameterByKey('pid');
  Store.commit('setUrlPid', urlPid || '');
  let kdbPoiId = '';
  try {
    KNB.retrieve({
      key: 'merchant:webview.key.poiinfo',
      success: (info) => {
        if (info.value) {
          info.value = JSON.parse(info.value);
          kdbPoiId = info.value.poiId;
          Store.commit('setKdbPoiId', info.value.poiId || '');
        }
      },
    });
  } catch (e) {
    Store.commit('setKdbPoiId', '');
  }
  if (!Store.state.currentPoi.poiId) {
    Store.commit('setCurrentPoiById', urlPid || kdbPoiId);
  }
};

/**
 * 获取唯一的partner角色信息
 * 在验证签约时用到,保证始终存在有效值,防止页面刷新丢失状态
 */
const getPartnerInfo = async () => {
  const partnerId = Store.getters['partnerModule/id'];

  if (partnerId) return;

  await Store.dispatch('partnerModule/initFromBackend');
};

const Interceptor = {
  /**
   * 拦截器
   * @returns {Promise.<void>}
   */
  before: async () => {
    getToken();
    getNowPoiId();
    getPartnerInfo();
    const {
      state,
      dispatch,
    } = Store;
    // 需要先获取poi信息和门店是否待签约
    if (!state.poiList.length) {
      await dispatch('fetchAdminAccount');
      await dispatch('fetchPoiData');
      await dispatch('fetchAccountType');
      await dispatch('fetchNotSignContracts');
      await dispatch('haveProxyPoi');
    }
    return Promise.resolve();
  },
};

export default Interceptor;
